const About = () => {
  return (
    <>
      <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                About Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    About
  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-70"
                  src="img/about.jpg"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3"></h6>
              <h1 className="mb-4">About Us</h1>
              <p className="">
                Mysore City Minority First Grade College is one of a reputed
                Educational Institute sponsored by S K Educational Society ®, at
                Mysore, Karnataka. The institution is engaged in providing
                Bachelor of Commerce (B Com) and Bachelor of Business Management
                (BBM) and Special courses like English Language courses, TOFEL,
                IELTS and Personality Development Classes for the all round
                development of the students. We train and empower them capable
                of selecting a successful career at this competitive world. We
                encourage our students to develop Entrepreneurship qualities and
                we support them to become Successful Entrepreneurs.
              </p>
              <p className="">
                The clear vision and progressive approach of our mentor and The
                President of S K Educational Society® has augmented the growth
                of our institution by leaps and bounds. He has a Passion for
                education, which is visible in his dealings with the students.
                Furthermore, he has always motivated young students to focus on
                their careers and bring out their talent potentials. Owing to
                the consistent quality education of services offered at our
                college, we have earned a respectable position in the education
                industry.
              </p>
              <p className="">
                We are able to impart quality education to our students with the
                support of our experienced and qualified faculties. They
                implement creative methodologies in their teaching styles to
                ensure better understanding of subjects. Every staff member of
                our institution is well-behaved and carries out their duties and
                responsibilities with utmost conviction. We are bestowed with
                state-of-the-art infrastructure, which is facilitated with all
                the necessary amenities and facilities.
              </p>
              <p className="">
                Our campus sprawls over a large area and offers a peaceful
                learning environment for students. Every department has a
                separate space, which is managed by the respective department
                heads. Moreover, college campus is situated in a posh area of
                Mysore.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid vision-mission-section">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-light text-center text-primary px-3">
              Our Foundation
            </h6>
            <h1 className="mb-5">Vision & Mission</h1>
            <p className="mb-5">
              Guiding our commitment to excellence in education and innovation
            </p>
          </div>

          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="vm-card">
                <div className="vm-icon">
                  <i className="fa fa-eye"></i>
                </div>
                <h3 className="vm-title">Our Vision</h3>
                <p>Knowledge with Wisdom.</p>

                <h5 className="mt-4 mb-3">Strategic Goals:</h5>
                <ul className="vm-list">
                  <li>Develop world-class digital learning platforms</li>
                  <li>Foster a global community of lifelong learners</li>
                  <li>Innovate in educational technology and pedagogy</li>
                  <li>Expand access to quality education worldwide</li>
                  <li>Build partnerships with industry leaders</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="vm-card">
                <div className="vm-icon">
                  <i className="fa fa-bullseye"></i>
                </div>
                <h3 className="vm-title">Our Mission</h3>
                <p>
                  Empower the young generation with quality education to make
                  them capable enough to lead a good life and support the nation
                  as responsible and patriotic citizens.
                </p>
                <p>
                  SK Education Trust provides valuable services in the field of
                  Information Technology and Vocational Training. Our expertise
                  includes Communication Skills, Spoken English, Business
                  English, and Corporate Communication Skills.
                </p>

                <p>
                  We also offer support activities such as teaching French and
                  German, corporate in-house training, body shopping, human
                  resource services, counseling, and translation of technical
                  documents for various industries.
                </p>
              </div>
            </div>
          </div>

          <div className="vm-divider wow fadeInUp" data-wow-delay="0.5s"></div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3"></h6>
            <h1 className="mb-5"></h1>
          </div>
          <p>
            SK Education Trust gives valuable services in the field of
            Information Technology and Vocational Training in Communication
            Skills, Spoken English, Business English and Corporate Communication
            Skills and many other support activity for establishing and
            counseling in varied areas of Teaching French, German, Corporate In
            house training, Body shopping, Human resources and Translate
            technical documents for any type of industry.
          </p>
        </div>
      </div>
    </>
  );
};
export default About;
